import React from 'react'
import PropTypes from 'prop-types'
import CreatableSelect from 'react-select/creatable'
import Select from 'react-select'
import { WindowedMenuList } from 'react-windowed-select'
import ImmutablePropTypes from 'react-immutable-proptypes'

import Label from '../../form/Label'

const InsuranceCompanySearch = (props) => {
  const {
    insuranceCompanies,
    handleChange,
    onCreateOption,
    value,
    excludeId,
    allowCreate = true,
    label = 'Obra Social',
    name = 'insuranceCompany',
  } = props

  const getDatasource = () => {
    if (!insuranceCompanies || insuranceCompanies.count() === 0) return []
    return insuranceCompanies
      .valueSeq()
      .filter(company => !excludeId || company.get('_id') !== excludeId)
      .map(company => ({
        value: company.get('_id'),
        label: company.get('name'),
      }))
      .toJS()
  }

  const handleInsuranceCompanySelected = (selected) => {
    handleChange({
      target: {
        name,
        value: selected ? selected.value : '',
      },
    })
  }

  const SelectComponent = allowCreate ? CreatableSelect : Select

  return (
    <div>
      <Label>{label}</Label>
      <div>
        <SelectComponent
          className='full-width'
          classNamePrefix='select'
          components={{ MenuList: WindowedMenuList }}
          options={getDatasource()}
          value={value}
          onChange={handleInsuranceCompanySelected}
          onCreateOption={allowCreate ? onCreateOption : undefined}
          isClearable={allowCreate}
          placeholder={allowCreate ? 'Seleccionar/Crear obra social' : 'Seleccionar obra social'}
          formatCreateLabel={allowCreate
            ? inputValue => `Crear "${inputValue.toUpperCase()}"`
            : undefined}
          menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
          menuPosition='fixed'
          styles={{
            menuPortal: base => ({ ...base, zIndex: 1400 }),
          }}
        />
      </div>
    </div>
  )
}

InsuranceCompanySearch.propTypes = {
  insuranceCompanies: ImmutablePropTypes.map,
  handleChange: PropTypes.func.isRequired,
  onCreateOption: PropTypes.func,
  value: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  excludeId: PropTypes.string,
  allowCreate: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
}

export default InsuranceCompanySearch
